exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-group {\n  margin: 0px !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/SPA/src/app/client/serviceObject/search/serviceObject-search.component.scss
// module id = ../../../../../src/app/client/serviceObject/search/serviceObject-search.component.scss
// module chunks = 0